import React from 'react';
import { Form } from 'react-bootstrap';
import Select from 'react-select';
import { customStyles } from '~/Styles/reactSelectStyles';

const FiltroDigitalizacao = ({ gruposEmpresa, codigoGrupoEmpresa, onChangeGE, tipo }) => {
  if (tipo === 'A') return null;

  const options = gruposEmpresa.map((ge) => ({
    value: ge.codigo_grupo_empresa,
    label: ge.nome,
  }));

  const valorSelecionado = options.find((o) => o.value === codigoGrupoEmpresa) || null;

  return (
    <Form.Group>
      <Form.Label className="small mb-1">Grupo de Empresa</Form.Label>
      <Select
        options={options}
        value={valorSelecionado}
        onChange={(opt) => onChangeGE(opt ? opt.value : null)}
        placeholder="Selecione a GE..."
        isClearable={false}
        styles={customStyles}
      />
    </Form.Group>
  );
};

export default FiltroDigitalizacao;
